export const NO_STYLE = {
    color: null,
    title: null,
    customTitle: null,
    effect: null,
    spotlight: false,
    signature: false,
    egg: false,
};
//# sourceMappingURL=live.js.map